<template>
    <single-page hide-sidebar>
      <template v-slot:toolbar-title>
        Περιοδικές Εργασίες
      </template>
      <template v-slot:main-content>
        <div>
          <v-dialog max-width="1000px" :fullscreen="isMobile" @close="onIssueClose" v-model="modal">
            <v-card v-if="issue">
              <v-toolbar tile dark class="secondary">
                <v-btn icon @click="onIssueClose">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>{{issue.IssueTitle}} </v-toolbar-title>
              </v-toolbar>
              <issue-actions-list empty-action-note="ΕΓΙΝΕ ΕΛΕΓΧΟΣ" v-if="issue" :actions="issue.Items"></issue-actions-list>
            </v-card>
          </v-dialog>
          <v-list v-if="projectPeriodicTasks.length">
            <issue-item @click="onIssueClick(task)" hide-icon :key="task.Issue_ID" hide-project-name full-date hide-time is-task
                        v-for="task in projectPeriodicTasks" :item="task"></issue-item>
          </v-list>
          <v-card-text v-else>
            Δεν υπάρχουν περιοδικές εργασίες.
          </v-card-text>
        </div>
      </template>
    </single-page>
</template>

<script>
import projectMixin from "@/views/Projects/mixins/projectMixin";
import {mapActions, mapGetters} from "vuex";
import IssueItem from "@/views/Issues/components/IssueListItem";
import IssueActionsList from "@/views/Issues/components/IssueActionsList";
import SinglePage from "@/components/templates/SinglePage";

export default {
  name: "ProjectPeriodicTasks",
  components: {SinglePage, IssueActionsList, IssueItem},
  data: () => ({
    issue: null,
    modal: false,
  }),
  mixins: [projectMixin],
  created() {
    this.getProjectPeriodicTasks()
  },
  methods: {
    onIssueClose() {
      this.issue = null;
      this.modal = false;
    },
    onIssueClick(issue) {
      this.modal = true;
      this.issue = issue;
    },
    ...mapActions('project', [
      'getProjectPeriodicTasks'
    ])
  },
  computed: {
    ...mapGetters([
      "isMobile"
    ]),
    ...mapGetters('project', [
      'projectPeriodicTasks'
    ])
  }
}
</script>

<style scoped>

</style>